import React from "react";
import TextAreaField from "../Forms/Input/TextAreaField";

interface Props {
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const CashCountObservations: React.FC<Props> = ({
  value,
  onChange,
  disabled
}) => {

  return (

    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">

      {/* HEADER */}
      <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">
        <h3 className="font-medium text-black dark:text-white">
          Observaciones del arqueo
        </h3>
      </div>

      {/* BODY */}
      <div className="p-6">

        <TextAreaField
          name="cashCountObservations"
          value={value || ""}
          rows={4}
          iconKey="note"
          placeholder="Escriba alguna observación sobre el arqueo..."
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
        />

      </div>

    </div>

  );

};

export default CashCountObservations;